import resolveConfig from 'tailwindcss/resolveConfig';

// Stencil has a fixed Rollup CommonJs Plugin configuration, only transforming cjs from node_modules.
import tailwindConfig from './../../node_modules/tailwind.config';

// Js does not know typescripts fixed array types [ a: string; b: string; ].
// Therefore we must cast to any...
const fullConfig = resolveConfig(tailwindConfig as any);
const breakpoints = fullConfig.theme.screens;

const cleanedBreakpoints = {};
Object.keys(breakpoints).map(x => {
  const breakpoint = breakpoints[x];
  let breakpointValue = '';
  if (typeof breakpoint === 'object') {
    breakpointValue = breakpoint.min;
  } else {
    breakpointValue = breakpoint;
  }

  cleanedBreakpoints[x] = breakpointValue.replace('px', '');
});

export function getBreakpointStart(breakpoint: string): number {
  if (!(breakpoint in cleanedBreakpoints)) {
    throw new Error(`Breakpoint ${breakpoint} not found. Please check your tailwind config.`);
  }
  return cleanedBreakpoints[breakpoint];
}

/**
 * Defines one of three screen size types used internally.
 */
export type ScreenSize = 'isMobile' | 'isTablet' | 'isDesktop';

export function innerWidthBetween(min: number, max: number): boolean {
  return window.innerWidth >= min && window.innerWidth < max;
}

function isMobileBreakpoint(): boolean {
  return innerWidthBetween(0, getBreakpointStart('tablet'));
}

function isTabletBreakpoint(): boolean {
  return innerWidthBetween(getBreakpointStart('tablet'), getBreakpointStart('desktop'));
}

/**
 * Returns the current ScreenSize.
 */
export function returnScreenSize(): ScreenSize {
  if (isMobileBreakpoint()) {
    return 'isMobile';
  } else if (isTabletBreakpoint()) {
    return 'isTablet';
  } else {
    return 'isDesktop';
  }
}
